import { render } from "./AuthItemGroupCreate.vue?vue&type=template&id=77ab62ef&scoped=true"
import script from "./AuthItemGroupCreate.vue?vue&type=script&lang=js"
export * from "./AuthItemGroupCreate.vue?vue&type=script&lang=js"

import "./AuthItemGroupCreate.vue?vue&type=style&index=0&id=77ab62ef&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ab62ef"]])

export default __exports__